import MessagesPage from "@/components/MessagesPage";

export default function AdminMessages() {
  return (
    <MessagesPage
      accent="violet"
      eyebrow="Admin · Messages"
      title="Operator inbox"
      audienceHint="All clinic and vendor conversations route into this shared inbox."
    />
  );
}
